import {lazy} from "react";

/**
 * 开发需要的路由
 */
export const devWebRouteList = [
    {
        path: '/dev/drawerTest',
        component: lazy(() =>
            import('../../../example/DrawerTest/DrawerTest'),
        ),
    },
]
